import { Text, Heading } from '@chakra-ui/layout'
import React from 'react'
import moment from 'moment'

export class DynamicConditions {
  constructor(item, skin) {
    if (item.rules.quick_type === 'first_time')
      this.firstTime = `Aplicable en la primera compra (Bienvenida): ${item.dv_cashback}.`
    else if (item.rules.quick_type === 'recurring')
      this.recurring = `Aplicable a partir de la segunda compra (Recurrente): ${item.dv_cashback}.`
    if (item.rules.end_date)
      this.dateValidity = `Vigencia desde el ${
        item.rules.start_date
          ? this.handleDate(item.rules.start_date)
          : this.handleDate(item.created)
      } hasta el ${this.handleDate(item.rules.end_date)}.`
    if (item.rules.start_time && item.rules.end_time)
      this.timeValidity = `Válido en el horario de ${this.handleTimeAmPm(
        item.rules.start_time
      )} a ${this.handleTimeAmPm(item.rules.end_time)}.`
    if (item.rules.min_total_transactions && item.rules.max_total_transactions)
      this.transactionRange = `Aplicable desde la compra número ${item.rules.min_total_transactions} hasta la número ${item.rules.max_total_transactions} inclusive del mes en curso.`
    else {
      this.minTotalTransactions = item.rules.min_total_transactions
        ? `Aplicable a partir de la compra número ${item.rules.min_total_transactions} del mes en curso.`
        : undefined
      this.maxTotalTransactions = item.rules.max_total_transactions
        ? `Aplicable hasta la compra número ${item.rules.max_total_transactions} inclusive del mes en curso.`
        : undefined
    }
    this.maxCashbackTransactions = item.rules.max_cashback_transactions
      ? `Se otorga un máximo de ${item.rules.max_cashback_transactions} veces por mes calendario.`
      : undefined
    this.maxAccumulatedCashback = item.rules.max_accumulated_cashback
      ? `Se otorga hasta un máximo de $${this.handleAmount(
          item.rules.max_accumulated_cashback / 100
        )}${
          skin === 'COPPEL' ? ' de dinero electrónico' : ''
        } por mes calendario.`
      : undefined
    this.minTransactionAmount = item.rules.min_transaction_amount
      ? `Aplicable a compras por un monto total mayor o igual a $${this.handleAmount(
          item.rules.min_transaction_amount / 100
        )}.`
      : undefined
    this.maxCashback = item.rules.max_cashback
      ? `Se otorga hasta un máximo de $${this.handleAmount(
          item.rules.max_cashback / 100
        )}${skin === 'COPPEL' ? ' de dinero electrónico' : ''} por compra.`
      : undefined
    this.accumulable =
      item.rules.accumulable && item.rules.total_transactions
        ? `Se otorga en la compra número ${item.rules.total_transactions} del mes en curso aplicándose sobre la sumatoria del monto total de las compras realizadas durante el mismo mes calendario (no se contabiliza la primera compra que hagas en la sucursal).`
        : undefined
    this.totalTransactions =
      item.rules.total_transactions && !item.rules.accumulable
        ? `Se otorga en la transacción número ${item.rules.total_transactions} del mes en curso.`
        : undefined
  }

  toList() {
    return [
      this.firstTime,
      this.recurring,
      this.dateValidity,
      this.startDate,
      this.endDate,
      this.timeValidity,
      this.startTime,
      this.endTime,
      this.transactionRange,
      this.minTotalTransactions,
      this.maxTotalTransactions,
      this.totalTransactions,
      this.maxCashbackTransactions,
      this.maxAccumulatedCashback,
      this.minTransactionAmount,
      this.maxCashback,
      this.accumulable
    ]
  }

  handleDate(date) {
    const formattedDate = moment.unix(date).format('DD/MM/YYYY')
    // const formattedTime = this.handleTimeAmPm(date)
    // return formattedDate + ' a las ' + formattedTime
    return formattedDate
  }

  handleTime(time) {
    const parsedTime = moment(time, 'HH:mm:ss').subtract(6, 'h')
    const formattedHours = parsedTime.format('H')
    const formattedMinutes = parsedTime.format('mm')

    return parsedTime.minutes() === 0
      ? formattedHours + 'hs'
      : `${formattedHours}${formattedMinutes}hs`
  }

  handleTimeAmPm(time) {
    const parsedTime = moment(time, 'HH:mm:ss').subtract(6, 'h')
    const formattedAmPm = parsedTime.format('a')
    const formattedHours = parsedTime.format('h')
    const formattedMinutes = parsedTime.format('mm')

    return parsedTime.minutes() === 0
      ? `${formattedHours}${formattedAmPm}`
      : `${formattedHours}:${formattedMinutes}${formattedAmPm}`
  }

  handleAmount(amount) {
    const formattedAmount = `${amount.toLocaleString('de-DE')}`
    return formattedAmount
  }
}

// const offer = {
//   business_type: {
//     type: 'physicalVenue',
//     url: ''
//   },
//   venue: {
//     _id: '64cc3e25b8357839b2484ae4',
//     name: 'error bug',
//     status: 'active',
//     business_type: 'physicalVenue',
//     address: {
//       _id: '64cc3e237204685c4c2353fd',
//       zipcode: '',
//       state: 'Ciudad de México',
//       location: {
//         type: 'Point',
//         coordinates: [-99.133208, 19.4326077]
//       },
//       street_address: 'Ciudad de México, CDMX, México'
//     }
//   },
//   business: {
//     _id: '64cc3e247204685c4c235402',
//     name: 'error bug',
//     media:
//       'https://assets-latest.reworth.app/processed/error_bug_2023-08-03-20:56:07_small.jpeg',
//     industry: ['electronics-software'],
//     socialMedia: []
//   },
//   name: 'error bug',
//   status: 'active',
//   price_level: 0,
//   rating: 0,
//   popularity: 0,
//   socialMedia: [],
//   media:
//     'https://assets-latest.reworth.app/processed/error_bug_2023-08-03-20:56:07_small.jpeg',
//   dv_category: 'Electrónica y Software',
//   raw_category: 'electronics-software',
//   dv_address: 'Ciudad de México, CDMX, México ',
//   dv_latlng: [-99.133208, 19.4326077],
//   cashback_decimal: 0.09,
//   dv_cashback: '9%',
//   expires: null,
//   created: 1693555443,
//   dv_name: 'error bug',
//   opening_hours: {},
//   rules: {
//     quick_type: 'recurring',
//     start_date: 1693555443,
//     end_date: 1704009843,
//     start_time: '20:00:00',
//     end_time: '03:00:00',
//     min_total_transactions: 3,
//     max_accumulated_cashback: 20000,
//     min_transaction_amount: 3000,
//     max_cashback: 5000,
//     // total_transactions: 7,
//     // accumulable: true,
//     max_cashback_transactions: 5
//   },
//   conditions:
//     'Cobertura geográfica de la promoción: Nacional, válida en el territorio de los Estados Unidos Mexicanos.'
// }

export const offerRulesTC = (item, skin, fontFamily) => {
  // item = offer
  const myStyle = {
    fontSize: '14px',
    color: 'brand.primaryDark',
    fontWeight: '450',
    fontFamily: fontFamily
  }
  const conditions = new DynamicConditions(item, skin).toList()
  return (
    <div>
      <Heading
        color={skin === 'FINSUS' ? '#23223F' :'brand.primary'}
        fontFamily={fontFamily}
        fontSize={['18px', '18px', '18px', '18px']}
        fontWeight='500'
        pb='16px'
      >
        Condiciones
      </Heading>
      <ul>
        {conditions.map((element, index) => {
          if (element)
            return (
              <li key={index} style={myStyle}>
                ◦ {element}
              </li>
            )
        })}
      </ul>
      {item.conditions && (
        <Text
          style={{ whiteSpace: 'pre-wrap' }}
          color='brand.primaryDark'
          fontSize={['14px', '14px', '14px', '14px']}
          fontWeight='450'
          my='24px'
          fontFamily={fontFamily}
        >
          {item.conditions}
        </Text>
      )}
    </div>
  )
}
